import { ofType } from "redux-observable";
import { EMPTY } from "rxjs";
import { retry, switchMap, switchMapTo } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { TypeActionQuest } from "../list/actionQuests";
export var epicQuestOpen = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuest.Open), switchMap(function (action) {
        var state = state$.value;
        return deps
            .netSend({
            id: CommandCode.QuestStart,
            props: {
                playerId: state.playerInfo.playerId,
                questId: action.questId,
            },
        })
            .pipe(retry(), switchMapTo(EMPTY));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/epics/epicQuestOpen.ts
// module id = 1967
// module chunks = 3